import 'reflect-metadata';
import {
  Expose,
  plainToInstance,
  instanceToPlain,
  Type,
} from 'class-transformer';
import { Article } from './Article';
import { Event } from './Event';

export class HomeExtra {
  @Type(() => Event)
  events: Event[];

  @Type(() => Article)
  articles: Article[];

  pv: string;
  tv: string;

  constructor(events: Event[], articles: Article[], pv: string, tv: string) {
    this.events = events;
    this.articles = articles;
    this.pv = pv;
    this.tv = tv;
  }

  static fromJson(json: Record<string, any>): HomeExtra {
    return plainToInstance(HomeExtra, json);
  }

  toJson(): any {
    return instanceToPlain(this);
  }
}
